<template>
  <div
    class="reader"
    :class="{ active: active }"
    v-show="isShow()"
    @click.stop="clickReader"
  >
    <div v-if="tag" class="tag" :class="[tag]"></div>
    <div class="center">
      <div class="figure-wrapper">
        <div class="figure">
          <img :src="$handleAssetsUrl(item.iconUrl)" alt />
        </div>
        <div class="badge"
          :class="{person: item.aiType === 2 && IsOldUser, [getBadgeClassName(4, 'enterpriseS')]: item.aiType === 2 && !IsOldUser, [getBadgeClassName(6, '')]: true}"
          v-if="item.aiType"></div>
      </div>
      <div class="content">
        <div class="row">
          <div class="label">{{ label }}</div>
          <div class="preview"
            @click.stop="onClickPreview"
            @mouseenter="onMouseEnterFigure"
            @mouseleave="onMouseLeaveFigure"
          >
            <iconfont name="#iconyinku-yulanbofang" font-size="18px"></iconfont>
            <audio
              v-if="audioActive"
              ref="audio"
              style="width: 0; height: 0"
              :src="$handleAssetsUrl(item.preview)"
            ></audio>
          </div>
        </div>
        <div class="row desc">{{ item.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import readerBus from './readerBus.js';
import { mapGetters } from 'vuex';
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [vipBadge],
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    active: {
      type: Boolean
    },
    item: {
      type: Object
    },
    activeTab: {
      type: String,
      default: ''
    },
    activeFilter: {
      type: String,
      default: 'all'
    }
  },
  name: 'Reader',
  components: {
    iconfont: () => import('@/platformCode/iconfont')
  },
  data () {
    return {
      audioActive: false,
      canPlay: false
    }
  },
  computed: {
    ...mapGetters([
      'IsOldUser',
    ]),
    visible () {
      let isActiveTab = (this.item.category || '').split(',').indexOf(this.$parent.activeTab) > -1;
      if (this.$parent.activeTab == '') {
        isActiveTab = true
      }

      let isActiveFilter = false;
      if (this.activeFilter === 'enterprise') {
        if ([1].includes(this.item.aiType)) {
          isActiveFilter = true;
        }
      } else if (this.activeFilter === 'person') {
        if ([2].includes(this.item.aiType)) {
          isActiveFilter = true;
        }
      } else if (this.activeFilter === 'normal') {
        if (![1, 2].includes(this.item.aiType)) {
          isActiveFilter = true;
        }
      } else {
        isActiveFilter = true;
      }

      return isActiveTab && isActiveFilter;
    },
    tag () {
      if (this.item.isCome) {
        return 'expiring-soon';
      }
      const map = {
        [0]: '',
        [1]: 'release',
        [2]: 'update'
      }
      return map[this.item.tag];
    }
  },
  created () {
    this.$bus.on('readerTestPlay', this.onTestPlay);
  },
  methods: {
    clickReader () {
      // readerBus.$emit('clickReader', {
      //   value: this.value
      // })
      this.$emit('clickReader', {
        ...this.item,
        value: this.value
      });
    },
    onClickPreview () {
      // readerBus.$emit('clickPreview', {
      //   value: this.value
      // });
      this.$bus.emit('readerTestPlay', this.item);
      this.$refs.audio && this.$refs.audio.play().catch(e => {
        this.$message({
          message: `音库试听失败，请稍后再试`,
          type: "error"
        });
      })
    },
    onTestPlay (item) {
      if (item.sourceId !== this.item.sourceId) {
        this.$refs.audio && this.$refs.audio.pause();
      }
    },
    isShow () {
      const hasCategory = !!this.item.category
      let isActiveTab = hasCategory && this.item.category.indexOf(this.activeTab) > -1;
      if (!this.activeTab) {
        isActiveTab = true
      }

      let isActiveFilter = false;
      if (this.activeFilter === 'enterprise') {
        if ([1].includes(this.item.aiType)) {
          isActiveFilter = true;
        }
      } else if (this.activeFilter === 'person') {
        if ([2].includes(this.item.aiType)) {
          isActiveFilter = true;
        }
      } else if (this.activeFilter === 'normal') {
        if (![1, 2].includes(this.item.aiType)) {
          isActiveFilter = true;
        }
      } else {
        isActiveFilter = true;
      }

      return isActiveTab && isActiveFilter;
    },
    onMouseEnterFigure () {
      this.audioActive = true;
    },
    onMouseLeaveFigure () {
      const audio = this.$refs.audio || {};
      if (audio.paused) {
        this.audioActive = false;
        this.canPlay = false;
      }
      if (audio && !audio.paused) {
        audio.addEventListener('ended', this.onAudioEnded);
      }
    },
    onAudioCanPlay () {
      this.canPlay = true;
    },
    onAudioEnded () {
      const audio = this.$refs.audio;
      this.audioActive = false;
      this.canPlay = false;
      audio && audio.removeEventListener('ended', this.onAudioEnded);
    }
  }
}
</script>

<style lang="scss" scoped>
.reader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 224px;
  height: 77px;
  background: #ffffff;
  border: 1px solid #d8dee9;
  opacity: 1;
  border-radius: 4px;
  color: #474261;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 6px;
  &:hover {
    border: 1px solid #5778fb;
    box-shadow: 0px 2px 10px rgba(96, 98, 121, 0.15);
  }
  & > .tag {
    position: absolute;
    top: 0;
    right: 0;
    width: 46px;
    height: 18px;
    background-image: url(../../../../assets/smartVoice/role-release.svg);
    background-size: 100% 100%;
    &.update {
      background-image: url(../../../../assets/smartVoice/role-update.svg);
    }
    &.expiring-soon {
      width: 54px;
      background-image: url(../../../../assets/smartVoice/role-expiring-soon.png);
    }
  }
}
.center {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.figure-wrapper {
  position: relative;
  margin-left: 20px;
  .badge {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 14px;
    // background: linear-gradient(353deg, #2F58FE 0%, #49A6FC 100%);
    opacity: 1;
    border-radius: 7px;
    color: #fff;
    font-size: 10px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0i5Zu+5bGCXzEiIGRhdGEtbmFtZT0i5Zu+5bGCIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCA1MCAxNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOnVybCgj5pyq5ZG95ZCN55qE5riQ5Y+YKTt9LmNscy0ye2lzb2xhdGlvbjppc29sYXRlO2ZvbnQtc2l6ZToxMHB4O2ZpbGw6I2ZmZjtmb250LWZhbWlseTpNaWNyb3NvZnRZYUhlaSwgTWljcm9zb2Z0IFlhSGVpO308L3N0eWxlPjxsaW5lYXJHcmFkaWVudCBpZD0i5pyq5ZG95ZCN55qE5riQ5Y+YIiB4MT0iMzMuMjUiIHkxPSItNi4yOSIgeDI9IjE2Ljc1IiB5Mj0iMjIuMjkiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMSwgMCwgMCwgLTEsIDAsIDE2KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzJmNThmZSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQ5YTZmYyIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjx0aXRsZT41MHgxNiDkvIHkuJpWSVDop5LmoIc8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTgsMEg0MmE4LDgsMCwwLDEsOCw4aDBhOCw4LDAsMCwxLTgsOEg4QTgsOCwwLDAsMSwwLDhIMEE4LDgsMCwwLDEsOCwwWiIvPjx0ZXh0IGNsYXNzPSJjbHMtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wOSAxMS41MykiPuS8geS4mlZJUDwvdGV4dD48L3N2Zz4=);

    &.enterpriseS {
      background-image: url(../../../../assets/enterpriseSVIP.svg);
    }
    &.pro {
      width: 30px;
      height: 18px;
      background-image: url(../../../../assets/pro.png);
    }
    &.proPlus {
      width: 32px;
      height: 18px;
      background-image: url(../../../../assets/proPlus.png);
    }
    &.person {
      background-image: url(../../../../../static/svg/payTypeSubscript/commonVip.svg);
    }
  }
}
.figure {
  flex-grow: 0;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
}
.content {
  margin-left: 8px;
  margin-right: 18px;
}
.row {
  display: flex;
  align-items: center;
  color: #606266;
  & .label {
    line-height: 1;
    margin-right: 12px;
  }
  & .preview {
    height: 18px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.row.desc {
  font-size: 12px;
  color: #898d96;
  margin-top: 4px;
  text-align: left;
}
.active {
  border: 1px solid #5778fb;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoice/reader.vue